import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Confirmation screen shown after a reklamasjon has been submitted.
@Component({
  selector: 'otto-olsen-claim-receipt',
  templateUrl: './otto-olsen-claim-receipt.component.html',
  styleUrl: './otto-olsen-claim-receipt.component.scss',
  standalone: false
})
export class OttoOlsenClaimReceiptComponent implements OnInit {
  public orderId: string;

  constructor(
    private route: ActivatedRoute,
    protected router: Router
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.orderId = params.get('orderId');
    });
  }

  protected backToOrders() {
    this.router.navigate(['/orders']);
  }
}
